var _path, _line, _rect, _rect2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartsGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 82,
    viewBox: "0 0 111 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 66.6681L27.5207 60.6053L49.9034 41.7143L55.9587 40.0239L75.2231 38.6518L93.0304 25.3809L102 23L110.541 22.1866L111 23.5587V81.1866H0V66.6681Z",
    fill: "url(#paint0_linear_0_1)",
    fillOpacity: 0.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 87.6,
    y1: 81,
    x2: 87.6,
    y2: 9,
    stroke: "url(#paint1_linear_0_1)",
    strokeWidth: 0.8,
    strokeDasharray: "1 1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    width: 30,
    height: 12,
    rx: 6,
    fill: "#151C2F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.25,
    y: 0.25,
    width: 29.5,
    height: 11.5,
    rx: 5.75,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3665 9.0696C83.1046 9.06795 82.8519 9.02403 82.6083 8.93786C82.3664 8.85168 82.1493 8.71165 81.957 8.51776C81.7648 8.32386 81.6123 8.067 81.4996 7.74716C81.3886 7.42732 81.3331 7.03456 81.3331 6.56889C81.3348 6.14134 81.3836 5.75935 81.4798 5.42294C81.5775 5.08487 81.7167 4.79818 81.8974 4.56285C82.0797 4.32753 82.2976 4.14856 82.5511 4.02592C82.8047 3.90163 83.0889 3.83949 83.4038 3.83949C83.7435 3.83949 84.0434 3.90578 84.3036 4.03835C84.5638 4.16927 84.7726 4.34742 84.93 4.5728C85.0891 4.79818 85.1853 5.0509 85.2184 5.33097H84.157C84.1155 5.15365 84.0285 5.01444 83.896 4.91335C83.7634 4.81226 83.5993 4.76172 83.4038 4.76172C83.0723 4.76172 82.8204 4.90589 82.6481 5.19425C82.4774 5.4826 82.3904 5.87453 82.3871 6.37003H82.4219C82.4981 6.21922 82.6009 6.09079 82.7301 5.98473C82.861 5.87701 83.0094 5.79498 83.1751 5.73864C83.3424 5.68063 83.5189 5.65163 83.7045 5.65163C84.0062 5.65163 84.2746 5.72289 84.5099 5.86541C84.7453 6.00627 84.9309 6.20017 85.0668 6.44709C85.2027 6.69401 85.2706 6.97656 85.2706 7.29474C85.2706 7.63944 85.1902 7.94602 85.0295 8.21449C84.8704 8.48295 84.6475 8.69342 84.3608 8.84588C84.0758 8.99669 83.7443 9.07126 83.3665 9.0696ZM83.3615 8.22443C83.5272 8.22443 83.6755 8.18466 83.8065 8.10511C83.9374 8.02557 84.0401 7.91785 84.1147 7.78196C84.1893 7.64607 84.2266 7.49361 84.2266 7.32457C84.2266 7.15554 84.1893 7.00391 84.1147 6.86967C84.0418 6.73544 83.9407 6.62855 83.8114 6.54901C83.6822 6.46946 83.5347 6.42969 83.369 6.42969C83.2447 6.42969 83.1295 6.45289 83.0234 6.49929C82.919 6.54569 82.8271 6.61032 82.7475 6.69318C82.6696 6.77604 82.6083 6.87216 82.5636 6.98153C82.5188 7.08925 82.4964 7.20443 82.4964 7.32706C82.4964 7.49112 82.5337 7.6411 82.6083 7.77699C82.6845 7.91288 82.7873 8.02143 82.9165 8.10263C83.0475 8.18383 83.1958 8.22443 83.3615 8.22443ZM86.2351 9L88.3455 4.82386V4.78906H85.8871V3.90909H89.4592V4.80149L87.3462 9H86.2351ZM89.7096 8.10511V7.25746L91.835 3.90909H92.5658V5.08239H92.1333L90.7934 7.20277V7.24254H93.8137V8.10511H89.7096ZM92.1531 9V7.84659L92.173 7.47124V3.90909H93.1823V9H92.1531Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 56.4174,
    y1: 23.1124,
    x2: 56.4174,
    y2: 81.1866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E657A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E657A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 88.5,
    y1: 81,
    x2: 88.5,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartsGraph);
export default __webpack_public_path__ + "static/media/carts_graph.fcb01262fa27765bda8873642e313f0b.svg";
export { ForwardRef as ReactComponent };